import { snakeCase } from "lodash";
import api from "PFCore/api";
import { Id, LocalisationKeys } from "PFTypes";

type FetchLocalisationKeysParams = {
  accountId: Id;
  key: LocalisationKeys;
  page?: number;
  perPage?: number;
  format?: "json" | "csv";
  locales?: string[];
};

export const fetchLocalisationKeys = ({
  accountId,
  key,
  page,
  perPage,
  format = "json",
  locales
}: FetchLocalisationKeysParams) =>
  api({
    url: `saas_admin/accounts/${accountId}/localisation/${snakeCase(key)}`,
    params: {
      perPage,
      page,
      format,
      locales
    }
  });
